/** Real email/password authentication against local Supabase, never an auth bypass. */
export function localAuthEnabled(): boolean {
  if (process.env.NODE_ENV !== 'development' || process.env.NEXT_PUBLIC_LOCAL_AUTH !== 'true') return false;
  try {
    const url = new URL(process.env.NEXT_PUBLIC_SUPABASE_URL || '');
    if (['127.0.0.1', 'localhost', '[::1]'].includes(url.hostname)) return true;
    // Explicit local launcher opt-in, routed to the loopback test database.
    const lanHost = process.env.NEXT_PUBLIC_LOCAL_LAN_HOST;
    return Boolean(lanHost && url.hostname === lanHost && url.port === '3001' && url.pathname === '/local-supabase');
  }
  catch { return false; }
}
export function safeAuthNext(value: string | null): string {
  return value?.startsWith('/') && !value.startsWith('//') && !/[\\\u0000-\u001f]/.test(value) ? value : '/library';
}
